<template>
    <div class="content bg">
        <div class="wrapper">
            <h2>核心优势</h2>
            <div class="content-wrapper">
                <ContentItem v-for="item in data" :item="item" :key="item.img"/>
            </div>
        </div>
    </div>
</template>
<script>
import ContentItem from "../components/ContentItem"
import content1 from "../assets/content1.svg"
import content2 from "../assets/content2.svg"
import content3 from "../assets/content3.svg"
const data = [
    {
        title: "丰富的欺骗环境，可灵活调整配置方案",
        desc: `360攻击欺骗防御系统得益于360安全大脑的赋能，吸纳专业攻防团队多年的积累，不断迭代和完善，拥有丰富的欺骗环境，产品有高度仿真的蜜罐、极具迷惑性的蜜标诱饵，用户可匹配业务场景设置针对性的欺骗方案。`,
        img: content1
    },
    {
        title: "溯源攻击者信息，化被动为主动",
        desc: `仿真服务和蜜饵在吸引黑客攻击时，会记录攻击信息，识别攻击指纹，结合360积累多年的威胁情报库，实现对威胁的溯源。`,
        img: content2
    },
    {
        title: "视频回放，记录攻击细节",
        desc: `当攻击者对虚拟服务进行攻击时，系统的录屏功能能够记录攻击者行为，可在系统后台通过视频方式进行攻击回放，可视化黑客攻击过程，并为取证提供支持。`,
        img: content3
    },
]
export default {
    components: {
        ContentItem
    },
    data() {
        return {
            data
        }
    }
}
</script>
<style>
.content-wrapper {
    display: flex;
    margin-top: 42px;
    padding-bottom: 42px;
}
</style>